import React, { useContext } from 'react';
import classnames from 'classnames';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import './SubmenuComponent.scss';
import { string, bool, element } from 'prop-types';

const SubmenuItem = ({ title, link, active }) => {

  const { channel } = useContext(ExperienceContext);

  const itemViewMode = () => {
    return channel === 'mobile' ? 'submenu-bar__item-mobile' : 'submenu-bar__item mobile-change';
  };

  return (

    <li className={itemViewMode()}>
      <a
        className={classnames('submenu-bar__item-link mobile-change', { 'submenu-bar__item-link-active': active })}
        href={link}
      >{title}
      </a>
    </li>
  );
};

const SubmenuBar = ({ classNames, children }) => {
  const wrapperClassNames = classnames('submenu-bar__col', classNames);
  return (
    <ul className={wrapperClassNames}>
      {children}
    </ul>
  );
};

SubmenuBar.displayName = 'SubmenuBar';

SubmenuItem.displayName = 'SubmenuBarItem';

SubmenuItem.propTypes = {
  title: string.isRequired,
  link: string.isRequired,
  active: bool
};

SubmenuItem.defaultProps = {
  active: false
};

SubmenuBar.propTypes = {
  classNames: string,
  children: element.isRequired
};

SubmenuBar.defaultProps = {
  classNames: ''
};

export { SubmenuBar, SubmenuItem };
